import { ISearchEntity, TrieNode } from '../types';

export const MAX_ITEMS = 10000;
export const createTrie = <T>(words: ISearchEntity<T>[]): TrieNode => {
  const root: TrieNode = { children: new Map(), isEnd: false };

  words.forEach((word) => {
    let node = root;
    for (const char of word.label) {
      if (!node.children.has(char)) {
        node.children.set(char, { children: new Map(), isEnd: false });
      }
      const nextNode = node.children.get(char);
      if (!nextNode) {
        throw new Error(`Unexpected undefined node for character: ${char}`);
      }
      node = nextNode;
    }
    node.isEnd = true;
  });

  return root;
};

export const searchTrie = <T>(root: TrieNode, prefix: string): ISearchEntity<T>[] => {
  let node: TrieNode | undefined = root;
  for (const char of prefix) {
    node = node.children.get(char);
    if (!node) return [];
  }
  return collectWords(node, prefix);
};

const collectWords = <T>(node: TrieNode, prefix: string): ISearchEntity<T>[] => {
  let results: ISearchEntity<T>[] = node.isEnd ? [{ label: prefix }] : [];
  node.children.forEach((child, char) => {
    results = results.concat(collectWords(child, prefix + char));
  });
  return results;
};
